export enum DocumentViewMode {
  View = 'view',
  Edit = 'edit',
}
